'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _constants = require('../../constants');
var _formField = require('./form-field');
var _formField2 = _interopRequireDefault(_formField);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var withFormField = function withFormField(WrappedComponent) {
  var _class, _temp;
  return _temp = _class = function (_Component) {
    _inherits(FormFieldWrapper, _Component);
    function FormFieldWrapper() {
      _classCallCheck(this, FormFieldWrapper);
      return _possibleConstructorReturn(this, (FormFieldWrapper.__proto__ || Object.getPrototypeOf(FormFieldWrapper)).apply(this, arguments));
    }
    _createClass(FormFieldWrapper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
          label = _props.label,
          error = _props.error,
          errors = _props.errors,
          name = _props.name,
          validating = _props.validating,
          helpText = _props.helpText,
          fieldCss = _props.fieldCss,
          extra = _props.extra,
          disabled = _props.disabled;
        return _react2.default.createElement(_formField2.default, {
          label: label,
          error: errors ? errors[name] : error,
          name: name,
          validating: (typeof validating === 'undefined' ? 'undefined' : _typeof(validating)) === 'object' ? !!~validating.indexOf(name) : validating,
          helpText: helpText,
          css: fieldCss,
          extra: extra,
          disabled: disabled
        }, _react2.default.createElement(WrappedComponent, this.props));
      }
    }]);
    return FormFieldWrapper;
  }(_react.Component), _class.propTypes = Object.assign({}, _constants.fieldPropTypes, {
    validating: (0, _propTypes.oneOfType)([_propTypes.bool, (0, _propTypes.arrayOf)(_propTypes.string)])
  }), _class.defaultProps = Object.assign({}, _constants.defaultFieldPropTypes, {
    validating: false
  }), _temp;
};
exports.default = withFormField;